import { render, staticRenderFns } from "./MemberPortal.vue?vue&type=template&id=06b61aec&scoped=true"
import script from "./MemberPortal.vue?vue&type=script&lang=js"
export * from "./MemberPortal.vue?vue&type=script&lang=js"
import style0 from "./MemberPortal.vue?vue&type=style&index=0&id=06b61aec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b61aec",
  null
  
)

export default component.exports